export const SUCCESS = 'success';
export const FAIL = 'fail';
export const chartEngine =
  window[`CustomDataChart_${window.CHARTS_VERSION.replace(/\./g, '_')}`]?.default || null;

export const sections = [
  'Page One',
  'World',
  'U.S.',
  'Politics',
  'Economy',
  'Business',
  'Tech',
  'Markets',
  'Art',
  'Life',
  'Real Estate',
  'Europe',
  'Asia',
];
